import Vue from "vue";
import { ToastPlugin, ModalPlugin } from "bootstrap-vue";
import VueCompositionAPI from "@vue/composition-api";
import "core-js";

import i18n from "@/libs/i18n";
import router from "./router";
import store from "./store";
import App from "./App.vue";

//VeeValidate Rules
import "@/libs/vee-validate/vee-validate.js";

// Global Components
import "./global-components";

// 3rd party plugins
import "@axios";
import "@/libs/acl";
import "@/libs/portal-vue";
import "@/libs/clipboard";
import "@/libs/toastification";
import "@/libs/sweet-alerts";
import "@/libs/vue-select";
import "@/libs/tour";

//Enums
import ENUMS from "@/enums";

// Google Analytics
import VueGtag from "vue-gtag";

// Componente de máscara para os inputs
import VueMask from "v-mask";

// Doc: https://matteo-gabriele.gitbook.io/vue-gtag/v/master/multiple-domain-tracking
Vue.use(VueGtag, {
  config: {
    // Abracaf Beta
    id: "G-NDQPY3G74B",
  },
  includes: [
    {
      // Abrare Beta
      id: "G-Z2SYVCB2C8",
    },
    {
      // Abcn Beta
      id: "G-LWDLRQ4Z0F",
    },
  ],
});

Vue.prototype.$ENUMS = ENUMS;

// BSV Plugin Registration
Vue.use(ToastPlugin);
Vue.use(ModalPlugin);

// Composition API
Vue.use(VueCompositionAPI);

Vue.use(VueMask);

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require("@core/assets/fonts/feather/iconfont.css"); // For form-wizard

// import core styles
require("@core/scss/core.scss");

// import assets styles
require("@/assets/scss/style.scss");

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
